import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeGetTextFor } from '../selectors';

const emptyOption = JSON.stringify('');

class Dropdown extends React.Component {
  static propTypes = {
    options: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string,
    getTextFor: PropTypes.func.isRequired,
  }

  static defaultProps = {
    selectedValue: emptyOption,
  }

  onSelectChange = (e) => {
    this.props.onChange(e.target.value);
  }

  renderOptions = () => {
    return this.props.options.map((option) => {
      return (
        <option value={option.value} key={option.value}>
          {option.label}
        </option>
      );
    });
  }

  render() {
    return (
      <select className="dropdown-input" onChange={this.onSelectChange} value={this.props.selectedValue}>
        <option value="" key="" disabled={this.props.selectedValue !== emptyOption}>
          {this.props.getTextFor('select-one')}
        </option>
        {this.renderOptions()}
      </select>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getTextFor: makeGetTextFor(state),
  };
};

export default connect(mapStateToProps)(Dropdown);
